import type { ReactNode } from 'react';
import { PaymentProvider } from './PaymentContext';
import { WalletProvider } from './WalletContext';
import { CurrencyProvider } from './CurrencyContext';
import { SecurityProvider } from './SecurityContext';
import { ScannerProvider } from './ScannerContext';
import { InternationalProvider } from './InternationalContext';

export * from './AuthContext';
export * from './PaymentContext';
export * from './WalletContext';
export * from './CurrencyContext';
export * from './SecurityContext';
export * from './ScannerContext';
export * from './InternationalContext';

/** Composes every payment-domain context provider in one place. */
export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <CurrencyProvider>
      <WalletProvider>
        <PaymentProvider>
          <SecurityProvider>
            <ScannerProvider>
              <InternationalProvider>{children}</InternationalProvider>
            </ScannerProvider>
          </SecurityProvider>
        </PaymentProvider>
      </WalletProvider>
    </CurrencyProvider>
  );
}
